
export function validateTotalWeight(rule, value, callback) {
    if (value == null) {
      callback(new Error('Should some weight.'));
    } else {
        // for kyat pat ywy
      if (typeof value === 'string') {

      const [kyat, pal, yway] = value.split("-")
  
      const condition1 = (kyat != 0 || pal != 0) && yway == 0;
      const condition2 = (kyat == 0 || pal == 0) && yway != 0;
      const condition3 = (kyat != 0 || pal != 0 || yway != 0);
  
      const isNotEmptyAndHaveWeight = condition1 || condition2 || condition3;
  
      if (isNotEmptyAndHaveWeight) {
        callback();
      } else {
        callback(new Error('Should have some weight.'));
      }

      } else { // for germ
        if(value !=0){
          callback();
        }
        else {
          callback(new Error('Should have some weight.'));
        }
      }

     
    }
  }

    export function validateQty(rule, value, callback) {
            if (value === 0) {
                callback(new Error('Should not be zero'));
            } else {
                callback(); // Validation passed
            }
        }

        export function  validateLessThanZeroAmount(rule, value, callback) {
          if (value <= 0 ) {
              callback(new Error('Invalid amount'));
          } else {
              callback(); // Validation passed
          }
      }